module.exports = __webpack_public_path__ + "img/Gallery_3_13.3e387796.jpeg";